"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4874],{

/***/ 50178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Search_default; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8270);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31549);






var SvgSearch = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Svg */ .ny, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Path */ .y$, {
            fill: "#786E64",
            d: "M9.5 16q-2.725 0-4.612-1.888T3 9.5t1.888-4.612Q6.778 3 9.5 3t4.613 1.888T16 9.5a6.1 6.1 0 0 1-1.3 3.8l5.6 5.6a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-5.6-5.6q-.75.6-1.725.95T9.5 16m0-2q1.875 0 3.188-1.312T14 9.5q0-1.876-1.312-3.187Q11.377 5.002 9.5 5T6.313 6.313 5 9.5t1.313 3.188T9.5 14"
        })
    }));
};
var Search_default = SvgSearch;



/***/ }),

/***/ 32661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ components_Dialog_Dialog; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+core@1.110.0_react@18.3.1/node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(64978);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@opendoor+tokens-studio@16.2.0/node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(64069);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(16675);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(92767);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/inputs/checkboxRadio/SimpleCheckbox.js
var SimpleCheckbox = __webpack_require__(43855);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(31549);
;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/Dialog/Actions.js









var dialogTokens = Components/* tokens.dialog */.T.dialog, Container = function(_param) /* @__PURE__ */ {
    var children = _param.children, $largerThanSM = _param.$largerThanSM, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "$largerThanSM"
    ]);
    return (0,jsx_runtime.jsx)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        marginTop: -1 * (0,cjs.getTokenValue)(dialogTokens.margin.mobile.bottom),
        $largerThanSM: (0,_object_spread/* default */.Z)({
            marginTop: -1 * (0,cjs.getTokenValue)(dialogTokens.margin.desktop.bottom)
        }, $largerThanSM)
    }, props), {
        children: children
    }));
}, ButtonContainer = function(param) {
    var children = param.children, buttonPosition = param.buttonPosition;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        paddingTop: dialogTokens.padding.mobile.betweenElements,
        paddingBottom: dialogTokens.margin.mobile.bottom,
        paddingHorizontal: dialogTokens.margin.mobile.leftRight,
        $largerThanSM: {
            paddingBottom: dialogTokens.margin.desktop.bottom,
            paddingHorizontal: dialogTokens.margin.desktop.leftRight,
            flexDirection: buttonPosition === "stacked" ? "column" : "row"
        },
        gap: dialogTokens.padding.actions.default,
        children: children
    });
}, Actions = function(_param) /* @__PURE__ */ {
    var buttonPosition = _param.buttonPosition, buttonOneProps = _param.buttonOneProps, buttonTwoProps = _param.buttonTwoProps, checkboxProps = _param.checkboxProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "buttonPosition",
        "buttonOneProps",
        "buttonTwoProps",
        "checkboxProps"
    ]);
    return (0,jsx_runtime.jsxs)(Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            checkboxProps && /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                paddingTop: dialogTokens.margin.mobile.top,
                paddingHorizontal: dialogTokens.margin.mobile.leftRight,
                $largerThanSM: {
                    paddingTop: 0,
                    paddingHorizontal: dialogTokens.margin.desktop.leftRight
                },
                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(SimpleCheckbox/* SimpleCheckbox */.A, (0,_object_spread/* default */.Z)({}, checkboxProps))
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsxs)(ButtonContainer, {
                buttonPosition: buttonPosition,
                children: [
                    buttonOneProps && /* @__PURE__ */ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread/* default */.Z)({
                        variant: "primary",
                        size: "small",
                        $largerThanSM: {
                            size: "medium",
                            flexGrow: 1
                        }
                    }, buttonOneProps)),
                    buttonTwoProps && /* @__PURE__ */ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread/* default */.Z)({
                        variant: "secondary",
                        size: "small",
                        $largerThanSM: {
                            size: "medium",
                            flexGrow: 1
                        }
                    }, buttonTwoProps))
                ]
            })
        ]
    }));
};


// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+dialog@1.110.0_react-dom@18.3.1_react@18.3.1__react-native@0.74.5_@babel+core@_5ffe9e8991f93d2b2aa578e5ef987f25/node_modules/@tamagui/dialog/dist/esm/Dialog.mjs + 45 modules
var Dialog = __webpack_require__(57634);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.12_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/ScrollView/index.js + 1 modules
var ScrollView = __webpack_require__(26330);
;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/shared/VisuallyHidden.js





var VisuallyHidden = function(_param) {
    var children = _param.children, visible = _param.visible, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "visible"
    ]);
    return visible ? children : /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        position: "absolute",
        width: 1,
        height: 1,
        margin: -1,
        zIndex: -1e4,
        overflow: "hidden",
        opacity: 1e-8,
        pointerEvents: "none"
    }, props), {
        children: children
    }));
};


;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/Dialog/Content.js









var Content_dialogTokens = Components/* tokens.dialog */.T.dialog, StyledTitle = (0,cjs.styled)(Dialog/* Dialog.Title */.Vq.Title, {
    name: "DialogTitle",
    fontFamily: "$body",
    color: Content_dialogTokens.color.content.default,
    variants: {
        typography: {
            "...fontSize": function(fontSize) {
                return {
                    fontSize: fontSize,
                    fontWeight: fontSize,
                    letterSpacing: fontSize,
                    lineHeight: fontSize
                };
            }
        }
    }
}), StyledDescription = (0,cjs.styled)(Dialog/* Dialog.Description */.Vq.Description, {
    name: "DialogDescription",
    fontFamily: "$body",
    color: Content_dialogTokens.color.content.default,
    variants: {
        typography: {
            "...fontSize": function(fontSize) {
                return {
                    fontSize: fontSize,
                    fontWeight: fontSize,
                    letterSpacing: fontSize,
                    lineHeight: fontSize
                };
            }
        }
    }
}), Title = function(propsIn) {
    var props = (0,cjs.useProps)(propsIn);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(StyledTitle, (0,_object_spread/* default */.Z)({}, props));
}, Description = function(propsIn) {
    var props = (0,cjs.useProps)(propsIn);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(StyledDescription, (0,_object_spread/* default */.Z)({}, props));
}, ScrollViewWrapper = function(param) {
    var children = param.children;
    var smallerThanMD = (0,cjs.useMedia)().smallerThanMD;
    return smallerThanMD ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Sheet.ScrollView */.Vq.Sheet.ScrollView, {
        flex: 0,
        children: children
    }) : /* @__PURE__ */ (0,jsx_runtime.jsx)(ScrollView/* default */.Z, {
        children: children
    });
}, Content = function(param) {
    var title = param.title, titleProps = param.titleProps, hideTitle = param.hideTitle, description = param.description, descriptionProps = param.descriptionProps, hideDescription = param.hideDescription, children = param.children;
    /* @__PURE__ */ return (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        flexGrow: 1,
        flexShrink: 1,
        paddingTop: Content_dialogTokens.margin.mobile.top,
        paddingBottom: Content_dialogTokens.margin.mobile.bottom,
        $largerThanSM: {
            paddingTop: Content_dialogTokens.margin.desktop.top,
            paddingBottom: Content_dialogTokens.margin.desktop.bottom
        },
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsx)(VisuallyHidden, {
                visible: !hideTitle,
                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    paddingHorizontal: Content_dialogTokens.margin.mobile.leftRight,
                    paddingBottom: Content_dialogTokens.padding.titleAndDescription.mobile,
                    $largerThanSM: {
                        paddingHorizontal: Content_dialogTokens.margin.desktop.leftRight,
                        paddingBottom: Content_dialogTokens.padding.titleAndDescription.desktop
                    },
                    children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Title, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        typography: Content_dialogTokens.typography.title.small
                    }, titleProps), {
                        $largerThanSM: (0,_object_spread/* default */.Z)({
                            typography: Content_dialogTokens.typography.title.medium,
                            marginRight: Content_dialogTokens.margin.desktop.titleRight
                        }, titleProps === null || titleProps === void 0 ? void 0 : titleProps.$largerThanSM),
                        children: title
                    }))
                })
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(ScrollViewWrapper, {
                children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                    paddingHorizontal: Content_dialogTokens.margin.mobile.leftRight,
                    $largerThanSM: {
                        paddingHorizontal: Content_dialogTokens.margin.desktop.leftRight
                    },
                    children: [
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(VisuallyHidden, {
                            visible: !hideDescription,
                            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Description, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                typography: Content_dialogTokens.typography.description.small
                            }, descriptionProps), {
                                $largerThanSM: (0,_object_spread/* default */.Z)({
                                    typography: Content_dialogTokens.typography.description.medium
                                }, descriptionProps === null || descriptionProps === void 0 ? void 0 : descriptionProps.$largerThanSM),
                                children: description
                            }))
                        }),
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                            children: children
                        })
                    ]
                })
            })
        ]
    });
};


// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.12_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/useWindowDimensions/index.js
var useWindowDimensions = __webpack_require__(12687);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/helpers/tokens.js
var tokens = __webpack_require__(17358);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Button/IconButton.js
var IconButton = __webpack_require__(36636);
// EXTERNAL MODULE: ../../node_modules/.pnpm/expo-blur@13.0.2_expo@55.0.24/node_modules/expo-blur/build/BlurView.web.js + 1 modules
var BlurView_web = __webpack_require__(35107);
;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/Dialog/BackgroundBlur.js







var BackgroundBlur = function(_param) {
    var blurRadius = _param.blurRadius, props = (0,_object_without_properties/* default */.Z)(_param, [
        "blurRadius"
    ]);
    var intensity = (0,react.useMemo)(function() {
        return (typeof blurRadius == "number" ? blurRadius : (0,cjs.getTokenValue)(blurRadius, "backgroundBlur")) * 5;
    }, [
        blurRadius
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(BlurView_web/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        intensity: intensity
    }));
};


;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/Dialog/Dialog.js











var Dialog_dialogTokens = Components/* tokens.dialog */.T.dialog, Dialog_Dialog = function(param) {
    var isOpen = param.isOpen, _animation = param.animation, animation = _animation === void 0 ? "accelerateDecelerateFastest" : _animation, setIsOpen = param.setIsOpen, _overlayColor = param.overlayColor, overlayColor = _overlayColor === void 0 ? "dark" : _overlayColor, analyticsName = param.analyticsName, trackImpression = param.trackImpression, _dismissable = param.dismissable, dismissable = _dismissable === void 0 ? !0 : _dismissable, _showCloseButton = param.showCloseButton, showCloseButton = _showCloseButton === void 0 ? !0 : _showCloseButton, children = param.children;
    var overlayProps = overlayColor === "dark" ? {
        backgroundColor: Dialog_dialogTokens.color.scrim
    } : overlayColor === "transparent" ? {
        backgroundColor: void 0
    } : {
        backgroundColor: Dialog_dialogTokens.color.scrimInverse,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(BackgroundBlur, {
            blurRadius: Dialog_dialogTokens.backgroundBlur.default,
            style: {
                position: "absolute",
                top: 0,
                bottom: 0,
                right: 0,
                left: 0
            }
        })
    }, maxHeightTokenValue = (0,tokens/* getPercentageTokenValue */.Re)(Dialog_dialogTokens.percentage.maxHeight), minHeightTokenValue = (0,tokens/* getPercentageTokenValue */.Re)(Dialog_dialogTokens.percentage.minHeightWidth), dimensions = (0,useWindowDimensions/* default */.Z)(), maxSheetHeight = (0,react.useMemo)(function() {
        var percent = parseInt(maxHeightTokenValue, 10);
        return cjs.isWeb ? "".concat(percent, "dvh") : 0.01 * percent * dimensions.height;
    }, [
        dimensions.height,
        maxHeightTokenValue
    ]), minSheetHeight = (0,react.useMemo)(function() {
        var percent = parseInt(minHeightTokenValue, 10);
        return cjs.isWeb ? "".concat(percent, "dvh") : 0.01 * percent * dimensions.height;
    }, [
        dimensions.height,
        minHeightTokenValue
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog */.Vq, {
        modal: !0,
        open: isOpen,
        onOpenChange: dismissable ? setIsOpen : void 0,
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Portal */.Vq.Portal, {
                children: [
                    /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Overlay */.Vq.Overlay, (0,_object_spread/* default */.Z)({
                        animation: animation,
                        animateOnly: [
                            "opacity"
                        ],
                        enterStyle: {
                            opacity: 0
                        },
                        exitStyle: {
                            opacity: 0
                        }
                    }, overlayProps), "overlay"),
                    /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Content */.Vq.Content, {
                        animation: animation,
                        animateOnly: [
                            "opacity",
                            "transform"
                        ],
                        enterStyle: {
                            opacity: 0,
                            y: 20
                        },
                        exitStyle: {
                            opacity: 0,
                            y: 20
                        },
                        overflow: "hidden",
                        padding: 0,
                        borderWidth: 0,
                        backgroundColor: Dialog_dialogTokens.color.background.default,
                        borderRadius: Dialog_dialogTokens.cornerRadius.desktop.default,
                        minWidth: (0,tokens/* getPercentageTokenValue */.Re)(Dialog_dialogTokens.percentage.minHeightWidth),
                        minHeight: minHeightTokenValue,
                        maxHeight: maxHeightTokenValue,
                        $largerThanSM: {
                            maxWidth: (0,tokens/* getPercentageTokenValue */.Re)(Dialog_dialogTokens.percentage.maxWidth)
                        },
                        children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                            analyticsName: analyticsName,
                            trackImpression: trackImpression,
                            flexGrow: 1,
                            flexShrink: 1,
                            position: "relative",
                            children: [
                                dismissable && showCloseButton && /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Close */.Vq.Close, {
                                    asChild: !0,
                                    children: /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* CloseButton */.PZ, {
                                        size: "large",
                                        analyticsName: "".concat(analyticsName, "-close"),
                                        position: "absolute",
                                        zIndex: 1,
                                        top: 0,
                                        right: 0,
                                        margin: Dialog_dialogTokens.padding.actions.closeIconButton.desktop
                                    })
                                }),
                                children
                            ]
                        })
                    }, "content")
                ]
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Adapt */.Vq.Adapt, {
                when: "smallerThanMD",
                children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(Dialog/* Dialog.Sheet */.Vq.Sheet, {
                    modal: !0,
                    dismissOnSnapToBottom: dismissable,
                    moveOnKeyboardChange: !0,
                    dismissOnOverlayPress: dismissable,
                    disableDrag: !dismissable,
                    animation: animation,
                    snapPointsMode: "fit",
                    children: [
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Sheet.Overlay */.Vq.Sheet.Overlay, (0,_object_spread/* default */.Z)({
                            animation: animation,
                            animateOnly: [
                                "opacity"
                            ],
                            enterStyle: {
                                opacity: 0
                            },
                            exitStyle: {
                                opacity: 0
                            }
                        }, overlayProps), "overlay"),
                        dismissable && /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Sheet.Handle */.Vq.Sheet.Handle, {
                            borderRadius: Dialog_dialogTokens.cornerRadius.mobile.handle,
                            height: Dialog_dialogTokens.mobile.handle.height,
                            width: Dialog_dialogTokens.mobile.handle.width,
                            alignSelf: "center",
                            marginLeft: 0,
                            marginRight: 0,
                            marginBottom: Dialog_dialogTokens.margin.mobile.handle.bottom,
                            backgroundColor: overlayColor === "dark" ? Dialog_dialogTokens.color.background.mobile.handle : Dialog_dialogTokens.color.background.mobile.handleInverse,
                            opacity: (0,tokens/* getOpacityTokenValue */.vs)(Dialog_dialogTokens.opacity.mobileHandle)
                        }),
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Sheet.Frame */.Vq.Sheet.Frame, {
                            backgroundColor: Dialog_dialogTokens.color.background.default,
                            borderTopLeftRadius: Dialog_dialogTokens.cornerRadius.mobile.default,
                            borderTopRightRadius: Dialog_dialogTokens.cornerRadius.mobile.default,
                            maxHeight: maxSheetHeight,
                            minHeight: minSheetHeight,
                            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Dialog/* Dialog.Adapt.Contents */.Vq.Adapt.Contents, {})
                        })
                    ]
                })
            })
        ]
    });
};


;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/Dialog/index.js




var components_Dialog_Dialog = (0,cjs.withStaticProperties)(Dialog_Dialog, {
    Content: Content,
    Actions: Actions
});



/***/ }),

/***/ 1393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Image_Image; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+core@1.110.0_react@18.3.1/node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(64978);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.12_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/Image/index.js + 2 modules
var Image = __webpack_require__(60197);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/helpers/analytics.js
var analytics = __webpack_require__(18352);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@opendoor+tokens-studio@16.2.0/node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(64069);
;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/Image/helpers.js

var ImageTokens = Components/* tokens.image */.T.image, getBorderRadiusByVariant = function(variant, orientation) {
    switch(variant){
        case "arch":
            return {
                borderTopLeftRadius: ImageTokens.radius.imageCornerRadius.full,
                borderTopRightRadius: ImageTokens.radius.imageCornerRadius.full,
                borderBottomLeftRadius: ImageTokens.radius.imageCornerRadius["16x"],
                borderBottomRightRadius: ImageTokens.radius.imageCornerRadius["16x"]
            };
        case "circle":
            return {
                borderTopLeftRadius: ImageTokens.radius.imageCornerRadius.full,
                borderTopRightRadius: ImageTokens.radius.imageCornerRadius.full,
                borderBottomLeftRadius: ImageTokens.radius.imageCornerRadius.full,
                borderBottomRightRadius: ImageTokens.radius.imageCornerRadius.full
            };
        case "article":
            return {
                borderTopLeftRadius: orientation === "top" || orientation === "left" ? ImageTokens.radius.imageCornerRadius["8x"] : ImageTokens.radius.imageCornerRadius["2x"],
                borderTopRightRadius: orientation === "top" || orientation === "right" ? ImageTokens.radius.imageCornerRadius["8x"] : ImageTokens.radius.imageCornerRadius["2x"],
                borderBottomLeftRadius: orientation === "bottom" || orientation === "left" ? ImageTokens.radius.imageCornerRadius["8x"] : ImageTokens.radius.imageCornerRadius["2x"],
                borderBottomRightRadius: orientation === "bottom" || orientation === "right" ? ImageTokens.radius.imageCornerRadius["8x"] : ImageTokens.radius.imageCornerRadius["2x"]
            };
        default:
            break;
    }
};


// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(31549);
;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/Image/Image.js










var BaseImageReactNative = (0,cjs.styled)(Image/* default */.Z, {
    name: "Image",
    variants: {
        variant: function(variant, extras) {
            var orientation = extras.props.orientation || "";
            return getBorderRadiusByVariant(variant, orientation);
        }
    }
}), Image_Image = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var analyticsName = _param.analyticsName, _trackImpression = _param.trackImpression, trackImpression = _trackImpression === void 0 ? !1 : _trackImpression, inViewThreshold = _param.inViewThreshold, source = _param.source, _enableZoom = _param.enableZoom, enableZoom = _enableZoom === void 0 ? !1 : _enableZoom, inProps = (0,_object_without_properties/* default */.Z)(_param, [
        "analyticsName",
        "trackImpression",
        "inViewThreshold",
        "source",
        "enableZoom"
    ]);
    inProps.variant === "circle" && (inProps.height = inProps.width);
    var _$ref = (0,_sliced_to_array/* default */.Z)((0,cjs.usePropsAndStyle)(inProps), 2), props = _$ref[0], style = _$ref[1];
    (0,react.useEffect)(function() {
        var imageRef = cjs.isWebTouchable && ref && "current" in ref ? ref.current : void 0;
        if (cjs.isWebTouchable && imageRef && enableZoom) {
            var imageElementScale = 1;
            var SCALE_MAX = 4, start = {
                x: 0,
                y: 0,
                distance: 0
            }, distance = function(event) {
                return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
            }, handleTouchStart = function(event) {
                event.touches.length === 2 && (event.preventDefault(), start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2, start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2, start.distance = distance(event));
            }, handleTouchMove = function(event) {
                if (event.touches.length === 2) {
                    event.preventDefault();
                    var scale;
                    (event === null || event === void 0 ? void 0 : event.scale) ? scale = event.scale : scale = distance(event) / start.distance, imageElementScale = Math.min(Math.max(1, scale), SCALE_MAX);
                    var deltaX = ((event.touches[0].pageX + event.touches[1].pageX) / 2 - start.x) * 2, deltaY = ((event.touches[0].pageY + event.touches[1].pageY) / 2 - start.y) * 2, transform = "translate3d(".concat(deltaX, "px, ").concat(deltaY, "px, 0) scale(").concat(imageElementScale, ")");
                    imageRef.style.transform = transform, imageRef.style.webkitTransform = transform, imageRef.style.zIndex = "9999", imageRef.style.transition = "ease 150ms";
                }
            }, handleTouchEnd = function() {
                imageRef.style.transform = "", imageRef.style.webkitTransform = "", imageRef.style.zIndex = "";
            };
            return imageRef === null || imageRef === void 0 ? void 0 : imageRef.addEventListener("touchstart", handleTouchStart), imageRef === null || imageRef === void 0 ? void 0 : imageRef.addEventListener("touchmove", handleTouchMove), imageRef === null || imageRef === void 0 ? void 0 : imageRef.addEventListener("touchend", handleTouchEnd), function() {
                imageRef === null || imageRef === void 0 ? void 0 : imageRef.removeEventListener("touchstart", handleTouchStart), imageRef === null || imageRef === void 0 ? void 0 : imageRef.removeEventListener("touchmove", handleTouchMove), imageRef === null || imageRef === void 0 ? void 0 : imageRef.removeEventListener("touchend", handleTouchEnd);
            };
        }
    }, [
        ref,
        enableZoom
    ]);
    var BaseImageWithProps = /* @__PURE__ */ (0,jsx_runtime.jsx)(BaseImageReactNative, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        accessibilityLabel: props.alt,
        source: source,
        style: style,
        ref: ref
    }));
    return analyticsName && trackImpression ? /* @__PURE__ */ (0,jsx_runtime.jsx)(analytics/* ComponentWithViewTracking */.o, (0,_object_spread/* default */.Z)({
        Component: BaseImageWithProps,
        analyticsName: analyticsName,
        eventName: "imageViewEvent",
        inViewThreshold: inViewThreshold,
        ref: ref
    }, props)) : BaseImageWithProps;
});



/***/ }),

/***/ 17764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ Dropdown; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@opendoor+tokens-studio@16.2.0/node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(64069);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+core@1.110.0_react@18.3.1/node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(64978);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.12_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/StyleSheet/index.js + 9 modules
var StyleSheet = __webpack_require__(97067);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.12_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/PixelRatio/index.js
var PixelRatio = __webpack_require__(56873);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/__generated__/icons/ChevronUp.js
var ChevronUp = __webpack_require__(12819);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/__generated__/icons/ChevronDown.js
var ChevronDown = __webpack_require__(23950);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/helpers/fontTokens.js
var fontTokens = __webpack_require__(14773);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/helpers/utils.js
var utils = __webpack_require__(10249);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/shared/TrackableContainer.js
var TrackableContainer = __webpack_require__(3462);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/inputs/shared/hooks.js
var hooks = __webpack_require__(26494);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/inputs/shared/InputError.js
var InputError = __webpack_require__(17787);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/inputs/shared/InputFrame.js
var InputFrame = __webpack_require__(44416);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/inputs/shared/InputLabel.js
var InputLabel = __webpack_require__(75467);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.12_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/View/index.js
var View = __webpack_require__(62262);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(31549);
;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/inputs/Dropdown/PickerSelect.js






var getSelectedItem = function(param) {
    var items = param.items, key = param.key, value = param.value;
    var idx = items.findIndex(function(item) {
        return item.key && key ? item.key === key : item.value === value;
    });
    return idx === -1 && (idx = 0), items[idx] || {};
}, PickerSelect = function(param) {
    var disabled = param.disabled, style = param.style, pickerProps = param.pickerProps, Icon = param.Icon, items = param.items, placeholder = param.placeholder, itemKey = param.itemKey, value = param.value, onValueChange = param.onValueChange;
    var allItems = [
        placeholder
    ].concat(items), ref = (0,react.useState)(getSelectedItem({
        items: allItems,
        key: itemKey,
        value: value
    })), selectedItem = ref[0], setSelectedItem = ref[1], handleValueChange = function(value2) {
        var selectedItem2 = getSelectedItem({
            items: allItems,
            value: value2
        });
        setSelectedItem(selectedItem2), onValueChange(selectedItem2.value);
    };
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(View/* default */.Z, {
        style: [
            {
                alignSelf: "stretch"
            },
            style === null || style === void 0 ? void 0 : style.viewContainer
        ],
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsx)(Picker, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                style: style === null || style === void 0 ? void 0 : style.inputWeb,
                enabled: !disabled,
                onValueChange: handleValueChange,
                selectedValue: selectedItem.value
            }, pickerProps), {
                children: allItems.map(function(item) {
                    return /* @__PURE__ */ (0,jsx_runtime.jsx)("option", {
                        value: item.value,
                        label: item.label,
                        children: item.label
                    }, item.key);
                })
            })),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(IconComponent, {
                Icon: Icon,
                style: style
            })
        ]
    });
}, IconComponent = function(param) {
    var Icon = param.Icon, style = param.style;
    return Icon ? /* @__PURE__ */ (0,jsx_runtime.jsx)(View/* default */.Z, {
        style: [
            {
                position: "absolute",
                right: 0
            },
            style === null || style === void 0 ? void 0 : style.iconContainer
        ],
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Icon, {})
    }) : null;
}, Select = /*#__PURE__*/ (0,react.forwardRef)(function(props, forwardedRef) {
    return /* @__PURE__ */ (0,jsx_runtime.jsx)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        ref: forwardedRef
    }));
}), Picker = /*#__PURE__*/ (0,react.forwardRef)(function(_param, forwardedRef) {
    var enabled = _param.enabled, onValueChange = _param.onValueChange, selectedValue = _param.selectedValue, children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "enabled",
        "onValueChange",
        "selectedValue",
        "children"
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Select, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        disabled: enabled === !1 ? !0 : void 0,
        onChange: function(e) {
            var _target = e.target, selectedIndex = _target.selectedIndex, value = _target.value;
            onValueChange && onValueChange(value, selectedIndex);
        },
        ref: forwardedRef,
        value: selectedValue
    }, other), {
        children: children
    }));
});


;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/inputs/Dropdown/Dropdown.js

















var textInputTokens = Components/* tokens.textInput */.T.textInput, Dropdown = function(_param) {
    var analyticsName = _param.analyticsName, trackImpression = _param.trackImpression, title = _param.title, supportText = _param.supportText, required = _param.required, externalErrorText = _param.errorText, externalInvalid = _param.invalid, disabled = _param.disabled, id = _param.id, name = _param.name, onFocus = _param.onFocus, externalOnBlur = _param.onBlur, onOpen = _param.onOpen, onClose = _param.onClose, onValueChange = _param.onValueChange, onOptionChange = _param.onOptionChange, options = _param.options, placeholderOption = _param.placeholderOption, prefilledValue = _param.prefilledValue, customErrorMessages = _param.customErrorMessages, onValidationChange = _param.onValidationChange, propsIn = (0,_object_without_properties/* default */.Z)(_param, [
        "analyticsName",
        "trackImpression",
        "title",
        "supportText",
        "required",
        "errorText",
        "invalid",
        "disabled",
        "id",
        "name",
        "onFocus",
        "onBlur",
        "onOpen",
        "onClose",
        "onValueChange",
        "onOptionChange",
        "options",
        "placeholderOption",
        "prefilledValue",
        "customErrorMessages",
        "onValidationChange"
    ]);
    var ref, ref1;
    var _ref = (0,cjs.useProps)(propsIn), _size = _ref.size, size = _size === void 0 ? "medium" : _size, props = (0,_object_without_properties/* default */.Z)(_ref, [
        "size"
    ]), pickerId = (0,hooks/* useInputId */.U0)(id), items = (0,react.useMemo)(function() {
        return options.map(function(param) {
            var label = param.label, value2 = param.value;
            return {
                label: label,
                value: value2,
                key: value2
            };
        });
    }, [
        options
    ]), placeholder = (0,react.useMemo)(function() {
        return {
            label: (ref = placeholderOption === null || placeholderOption === void 0 ? void 0 : placeholderOption.label) !== null && ref !== void 0 ? ref : "Select an item",
            value: (ref1 = placeholderOption === null || placeholderOption === void 0 ? void 0 : placeholderOption.value) !== null && ref1 !== void 0 ? ref1 : "",
            key: "placeholder"
        };
    }, [
        placeholderOption === null || placeholderOption === void 0 ? void 0 : placeholderOption.label,
        placeholderOption === null || placeholderOption === void 0 ? void 0 : placeholderOption.value
    ]), ref2 = (0,react.useState)(prefilledValue !== null && prefilledValue !== void 0 ? prefilledValue : placeholder.value), value = ref2[0], setValue = ref2[1], ref3 = (0,react.useState)(), internalErrorText = ref3[0], setInternalErrorText = ref3[1], ref4 = (0,react.useState)("unknown"), internalValidationState = ref4[0], setInternalValidationState = ref4[1], validate = (0,react.useCallback)(function(value2) {
        var errorText2, validationState = "valid";
        var ref;
        return value2 === "" && required && (errorText2 = (ref = customErrorMessages === null || customErrorMessages === void 0 ? void 0 : customErrorMessages.fieldRequired) !== null && ref !== void 0 ? ref : "This field is required", validationState = "invalid"), setInternalErrorText(errorText2), setInternalValidationState(validationState), validationState;
    }, [
        required,
        customErrorMessages === null || customErrorMessages === void 0 ? void 0 : customErrorMessages.fieldRequired
    ]), handleValueChange = (0,react.useCallback)(function(val) {
        var value2 = typeof val == "string" ? val : "";
        setValue(value2);
        var option = options.find(function(opt) {
            return opt.value === value2;
        }) || placeholderOption || {
            label: placeholder.label,
            value: placeholder.value
        };
        onValueChange && onValueChange(value2), onOptionChange && onOptionChange(option);
        var validationState = validate(value2);
        onValidationChange && onValidationChange(validationState);
    }, [
        validate,
        onValueChange,
        onOptionChange,
        onValidationChange,
        options,
        placeholderOption,
        placeholder
    ]), onBlur = (0,react.useCallback)(function(e) {
        validate(value), externalOnBlur && externalOnBlur(e);
    }, [
        value,
        validate,
        externalOnBlur
    ]), errorText = externalErrorText !== null && externalErrorText !== void 0 ? externalErrorText : internalErrorText, invalid = !!errorText || externalInvalid || internalValidationState === "invalid", ref5 = (0,hooks/* useInputState */.U1)({
        errorText: errorText,
        invalid: invalid,
        disabled: disabled,
        onFocus: onFocus,
        onBlur: onBlur
    }), state = ref5.state, handleBlur = ref5.handleBlur, handleFocus = ref5.handleFocus, setFocused = ref5.setFocused, handleOpen = (0,react.useCallback)(function() {
        setFocused(!0), onOpen && onOpen();
    }, [
        setFocused,
        onOpen
    ]), handleClose = (0,react.useCallback)(function() {
        setFocused(!1), validate(value), onClose && onClose();
    }, [
        setFocused,
        validate,
        value,
        onClose
    ]), ref6 = (0,react.useMemo)(function() {
        return getStyles({
            size: size,
            state: state
        });
    }, [
        size,
        state
    ]), frameHeight = ref6.frameHeight, inputStyles = ref6.inputStyles, viewContainerStyles = ref6.viewContainerStyles, placeholderStyles = ref6.placeholderStyles, iconContainerStyles = ref6.iconContainerStyles, iconStyles = ref6.iconStyles;
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(TrackableContainer/* TrackableContainer */.z, {
        analyticsName: analyticsName,
        trackImpression: trackImpression,
        eventName: "inputViewEvent",
        gap: textInputTokens.padding.gap.textAndField[size],
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsx)(InputLabel/* InputLabel */.A, {
                size: size,
                title: title,
                supportText: supportText,
                id: pickerId,
                required: required,
                state: state
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(InputFrame/* InputFrame */.z, {
                size: size,
                state: state,
                height: frameHeight,
                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(PickerSelect, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    items: items,
                    disabled: disabled,
                    placeholder: placeholder,
                    value: value,
                    onValueChange: handleValueChange,
                    pickerProps: (0,_object_spread/* default */.Z)({
                        id: pickerId,
                        onFocus: handleFocus,
                        onBlur: handleBlur
                    }, cjs.isWeb ? {
                        "aria-invalid": state === "error",
                        "aria-required": required,
                        name: name
                    } : {}),
                    onOpen: handleOpen,
                    onClose: handleClose,
                    useNativeAndroidPickerStyle: !1,
                    fixAndroidTouchableBug: !0,
                    style: {
                        viewContainer: viewContainerStyles,
                        inputWeb: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputStyles, value === placeholder.value ? placeholderStyles : {}), {
                            outlineStyle: "none",
                            cursor: state === "inactive" ? "default" : "pointer",
                            appearance: "none",
                            textOverflow: "ellipsis"
                        }),
                        inputIOS: inputStyles,
                        chevronUp: {
                            display: "none"
                        },
                        chevronDown: {
                            display: "none"
                        },
                        inputAndroid: inputStyles,
                        headlessAndroidContainer: StyleSheet/* default.absoluteFill */.Z.absoluteFill,
                        iconContainer: iconContainerStyles,
                        placeholder: placeholderStyles
                    },
                    touchableWrapperProps: cjs.isAndroid ? {
                        style: viewContainerStyles
                    } : {},
                    Icon: function() {
                        return(// This toggles the chevron icon on ios/android. On web, there doesn't
                        // seem to be a good way to know if the picker is open because it's
                        // possible to focus the picker without opening it and `select`
                        // doesn't have an event corresponding to open/close.
                        !cjs.isWeb && state === "focused" ? /* @__PURE__ */ (0,jsx_runtime.jsx)(ChevronUp/* default */.Z, (0,_object_spread/* default */.Z)({}, iconStyles)) : /* @__PURE__ */ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, (0,_object_spread/* default */.Z)({}, iconStyles)));
                    }
                }))
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(InputError/* InputError */.p, {
                errorText: errorText
            })
        ]
    });
}, getStyles = function(param) {
    var size = param.size, state = param.state;
    var typopgraphyToken = textInputTokens.typography.valueText[size], colorToken = (0,utils/* isKeyOfObject */.E)(state, textInputTokens.color.content.valueText.state) ? textInputTokens.color.content.valueText.state[state] : textInputTokens.color.content.valueText.default, paddingVerticalToken = textInputTokens.padding.topBottom[size], paddingHorizontalToken = textInputTokens.padding.leftRight[size], borderWidthToken = textInputTokens.borderWidth.default, paddingVertical = (0,cjs.getTokenValue)(paddingVerticalToken, "space"), paddingHorizontal = (0,cjs.getTokenValue)(paddingHorizontalToken, "space"), borderWidth = (0,cjs.getTokenValue)(borderWidthToken, "space"), lineHeight = (0,fontTokens/* getTypographyValue */.Yp)(typopgraphyToken, "lineHeight"), fontScale = PixelRatio/* default.getFontScale */.Z.getFontScale(), frameHeight = lineHeight * fontScale + 2 * paddingVertical + 2 * borderWidth, viewContainerStyles = {
        position: "absolute",
        top: -borderWidth,
        bottom: -borderWidth,
        left: -borderWidth,
        right: -borderWidth,
        zIndex: 1
    }, iconContainerStyles = {
        top: 0,
        bottom: 0,
        right: paddingHorizontal + borderWidth,
        justifyContent: "center",
        zIndex: -1
    }, fontWeight = (0,fontTokens/* getTypographyValue */.Yp)(typopgraphyToken, "weight"), iconSize = size === "small" || size === "xsmall" ? 20 : 24, iconGap = (0,cjs.getTokenValue)(textInputTokens.padding.gap.textAndIcon.default, "space"), inputStyles = {
        fontFamily: (0,fontTokens/* getFontName */.Yw)(fontWeight),
        fontSize: (0,fontTokens/* getTypographyValue */.Yp)(typopgraphyToken, "size"),
        fontWeight: fontWeight,
        letterSpacing: (0,fontTokens/* getTypographyValue */.Yp)(typopgraphyToken, "letterSpacing"),
        color: (0,cjs.getTokenValue)(colorToken, "color"),
        borderWidth: borderWidth,
        borderColor: "transparent",
        backgroundColor: "transparent",
        height: frameHeight,
        paddingVertical: paddingVertical,
        paddingLeft: paddingHorizontal,
        paddingRight: paddingHorizontal + iconSize + iconGap
    }, placeholderStyles = {
        color: (0,cjs.getTokenValue)(textInputTokens.color.content.placeholderText.default, "color")
    };
    return {
        frameHeight: frameHeight,
        viewContainerStyles: viewContainerStyles,
        iconContainerStyles: iconContainerStyles,
        inputStyles: inputStyles,
        placeholderStyles: placeholderStyles,
        iconStyles: {
            size: iconSize,
            color: colorToken
        }
    };
};



/***/ }),

/***/ 43855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ SimpleCheckbox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59106);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64069);
/* harmony import */ var _tamagui_checkbox_headless__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6805);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _generated_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1227);
/* harmony import */ var _helpers_useObservabilitySafe__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51330);
/* harmony import */ var _helpers_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10249);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16675);
/* harmony import */ var _shared_TrackableContainer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3462);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56032);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26494);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38344);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31549);
















var checkboxTokens = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_1__/* .tokens.radioCheckbox */ .T.radioCheckbox, SimpleCheckbox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) {
    var analyticsName = _param.analyticsName, label = _param.label, value = _param.value, _defaultChecked = _param.defaultChecked, defaultChecked = _defaultChecked === void 0 ? !1 : _defaultChecked, disabled = _param.disabled, invalid = _param.invalid, id = _param.id, onPress = _param.onPress, name = _param.name, trackImpression = _param.trackImpression, checked = _param.checked, ariaLabel = _param.ariaLabel, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "analyticsName",
        "label",
        "value",
        "defaultChecked",
        "disabled",
        "invalid",
        "id",
        "onPress",
        "name",
        "trackImpression",
        "checked",
        "ariaLabel"
    ]);
    var _$ref = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.useProps)(props), _size = _$ref.size, size = _size === void 0 ? "medium" : _size, trackJourneyEvent = (0,_helpers_useObservabilitySafe__WEBPACK_IMPORTED_MODULE_5__/* .useObservabilitySafe */ .r)().trackJourneyEvent, _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultChecked), internalChecked = _$ref1[0], setInternalChecked = _$ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        checked !== void 0 && setInternalChecked(checked);
    }, [
        checked
    ]);
    var onCheckedChange = function(e) {
        e.stopPropagation(), onPress && onPress(value, !internalChecked), trackJourneyEvent("platform", "checkboxClickEvent", {
            targetName: analyticsName,
            optionName: value
        });
    }, _$ref2 = (0,_tamagui_checkbox_headless__WEBPACK_IMPORTED_MODULE_6__/* .useCheckbox */ .O)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        name: name,
        value: value,
        defaultChecked: defaultChecked,
        disabled: disabled,
        onPress: onCheckedChange
    }, props), [
        internalChecked,
        setInternalChecked
    ], ref), checkboxProps = _$ref2.checkboxProps, checkboxRef = _$ref2.checkboxRef, bubbleInput = _$ref2.bubbleInput, inputId = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useInputId */ .U0)(id), _$ref3 = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_9__/* .useCheckBoxRadioState */ .D)({
        checked: internalChecked,
        disabled: disabled,
        invalid: invalid
    }), rowState = _$ref3.rowState, buttonState = _$ref3.buttonState, handleFocus = _$ref3.handleFocus, handleBlur = _$ref3.handleBlur, _$ref4 = getCheckMarkIconStyle(size, buttonState), checkMarkSize = _$ref4.checkMarkSize, checkMarkColor = _$ref4.checkMarkColor;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_shared_TrackableContainer__WEBPACK_IMPORTED_MODULE_10__/* .TrackableContainer */ .z, {
        analyticsName: analyticsName,
        trackImpression: trackImpression,
        eventName: "checkboxViewEvent",
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(CheckboxRowButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, checkboxProps), {
            "aria-invalid": _tamagui_core__WEBPACK_IMPORTED_MODULE_4__.isWeb ? invalid : void 0,
            "aria-required": _tamagui_core__WEBPACK_IMPORTED_MODULE_4__.isWeb ? props.required : void 0,
            "aria-label": ariaLabel,
            ref: checkboxRef,
            size: size,
            state: rowState,
            onFocus: handleFocus,
            onBlur: handleBlur,
            focusable: !disabled,
            id: inputId,
            children: [
                /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(Checkbox, {
                    disabled: disabled,
                    size: size,
                    state: {
                        state: buttonState,
                        checked: internalChecked
                    },
                    onFocus: handleFocus,
                    onBlur: handleBlur,
                    focusable: !1,
                    alignSelf: "flex-start",
                    children: [
                        internalChecked === !0 && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_generated_icons__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            size: checkMarkSize,
                            color: checkMarkColor
                        }),
                        bubbleInput
                    ]
                }),
                label && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .x, {
                    alignSelf: "center",
                    flex: 1,
                    children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                        alignSelf: "flex-start",
                        textAlign: "left",
                        tag: "label",
                        htmlFor: id,
                        cursor: "inherit",
                        typography: checkboxTokens.typography.simpleCheckbox[size],
                        color: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_15__/* .isKeyOfObject */ .E)(buttonState, checkboxTokens.color.content.valueText.state) ? checkboxTokens.color.content.valueText.state[buttonState] : checkboxTokens.color.content.valueText.default,
                        children: label
                    })
                })
            ]
        }))
    });
}), CheckboxRowButton = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.View, {
    tag: "button",
    display: "flex",
    flexDirection: "row",
    /**
   * Combined size and state into one variant because there are multiple times we need to use both to determine the style (especially for small/xsmall)
   * Seperating these two variants causes confusion and causes strange overrides
   */ variants: {
        state: function(state) {
            return {
                cursor: state === "inactive" ? "default" : "pointer"
            };
        },
        size: function(size) {
            var updatedSize = size === "xsmall" ? "small" : size;
            return {
                borderColor: "$transparent",
                backgroundColor: "$transparent",
                paddingTop: checkboxTokens.margin.simpleCheckbox.topBottom[updatedSize],
                paddingBottom: checkboxTokens.margin.simpleCheckbox.topBottom[updatedSize],
                gap: checkboxTokens.padding.simpleCheckbox[updatedSize]
            };
        }
    }
}), Checkbox = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_4__.Stack, {
    borderWidth: checkboxTokens.borderWidth.default,
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "auto",
    alignSelf: "center",
    variants: {
        size: function(size) {
            var widthAndHeight = {
                xsmall: checkboxTokens.size.element.radio.exterior.xsmall,
                small: checkboxTokens.size.element.radio.exterior.small,
                medium: checkboxTokens.size.element.radio.exterior.medium
            };
            return {
                borderRadius: checkboxTokens.cornerRadius.element.checkbox[size === "small" || size === "xsmall" ? "smallXsmall" : size],
                width: widthAndHeight[size],
                height: widthAndHeight[size]
            };
        },
        // eslint-disable-next-line jsdoc/require-jsdoc
        state: function(param) {
            var state = param.state, checked = param.checked;
            return {
                borderColor: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_15__/* .isKeyOfObject */ .E)(state, checkboxTokens.color.border.element.checkbox.state) ? checkboxTokens.color.border.element.checkbox.state[state] : checkboxTokens.color.border.element.checkbox.default,
                backgroundColor: (checked || state === "inactive") && (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_15__/* .isKeyOfObject */ .E)(state, checkboxTokens.color.background.element.checkboxRadio.state) ? checkboxTokens.color.background.element.checkboxRadio.state[state] : "$transparent"
            };
        }
    }
}), getCheckMarkIconStyle = function(size, state) {
    return {
        checkMarkSize: size === "small" ? 20 : 24,
        checkMarkColor: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_15__/* .isKeyOfObject */ .E)(state, checkboxTokens.color.content.element.checkIcon.state) ? checkboxTokens.color.content.element.checkIcon.state[state] : checkboxTokens.color.content.element.checkIcon.default
    };
};



/***/ }),

/***/ 38344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useCheckBoxRadioState; },
/* harmony export */   "q": function() { return /* binding */ getCustomRadioCheckboxRowStyling; }
/* harmony export */ });
/* harmony import */ var _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64069);
/* harmony import */ var _helpers_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10249);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26494);



var radioCheckbox = _opendoor_tokens_studio_dist_bricks_next_tokens_Components__WEBPACK_IMPORTED_MODULE_0__/* .tokens.radioCheckbox */ .T.radioCheckbox, useCheckBoxRadioState = function(param) {
    var disabled = param.disabled, errorText = param.errorText, invalid = param.invalid, onFocus = param.onFocus, onBlur = param.onBlur, checked = param.checked;
    var ref = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useInputState */ .U1)({
        disabled: disabled,
        errorText: errorText,
        invalid: invalid,
        onFocus: onFocus,
        onBlur: onBlur
    }), state = ref.state, handleFocus = ref.handleFocus, handleBlur = ref.handleBlur, setFocused = ref.setFocused, rowState = state || (checked && checked !== "indeterminate" ? "selected" : void 0);
    return {
        rowState: rowState,
        buttonState: state === "focused" && checked ? "selected" : rowState,
        handleFocus: handleFocus,
        handleBlur: handleBlur,
        setFocused: setFocused
    };
}, getCustomRadioCheckboxRowStyling = function(param) {
    var size = param.size, state = param.state;
    var isXSmall = size === "xsmall", disabled = state === "inactive", focused = state === "focused", hoverStyle = disabled ? {} : {
        borderColor: isXSmall ? "$transparent" : radioCheckbox.color.border.row.state.hover,
        backgroundColor: isXSmall ? radioCheckbox.color.background.element.row.state.hover : "$transparent"
    }, focusStyle = focused && !disabled ? {
        borderColor: radioCheckbox.color.border.row.state.focused,
        borderWidth: radioCheckbox.borderWidth.default
    } : {}, cursor = state === "inactive" ? "default" : "pointer", borderColor = isXSmall ? void 0 : (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .isKeyOfObject */ .E)(state, radioCheckbox.color.border.row.state) ? radioCheckbox.color.border.row.state[state] : radioCheckbox.color.border.row.default;
    return {
        backgroundColor: "$transparent",
        height: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .isKeyOfObject */ .E)(size, radioCheckbox.size.rowHeight) ? radioCheckbox.size.rowHeight[size] : 0,
        paddingRight: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .isKeyOfObject */ .E)(size, radioCheckbox.padding.leftRight) ? radioCheckbox.padding.leftRight[size] : 0,
        paddingLeft: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .isKeyOfObject */ .E)(size, radioCheckbox.padding.leftRight) ? radioCheckbox.padding.leftRight[size] : 0,
        borderRadius: (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_2__/* .isKeyOfObject */ .E)(size, radioCheckbox.cornerRadius.row) ? radioCheckbox.cornerRadius.row[size] : 0,
        borderWidth: radioCheckbox.borderWidth.default,
        // hides the border if it's xsmall
        borderColor: borderColor || "$transparent",
        hoverStyle: hoverStyle,
        focusStyle: focusStyle,
        cursor: cursor
    };
};



/***/ })

}]);